import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getUploadsByTag } from '@wix/da-shared-react/pkg/redux/uploads/selectors';
import { getNotificationQueue } from '@wix/da-shared-react/pkg/Notifications/redux/selectors';
import {
  clearInactiveUploads,
  cancelFileUpload,
} from '@wix/da-shared-react/pkg/redux/uploads/actions';
import { AppState } from '../../types/store';
import { getCompletedUploadsWithDeviation } from '../../selectors/studio';
import { STUDIO_UPLOADS_NAMESPACE } from '../../../constants';
import { Props } from './StudioUploadsList';

export type StateProps = Pick<
  Props,
  'activeUploads' | 'completedUploads' | 'shouldCloseDialog'
>;
export type DispatchProps = Pick<
  Props,
  'clearInactiveUploads' | 'cancelFileUpload'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  activeUploads: getUploadsByTag(state, STUDIO_UPLOADS_NAMESPACE),
  completedUploads: getCompletedUploadsWithDeviation(state),
  shouldCloseDialog: getNotificationQueue(state, 'default').length > 0,
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  clearInactiveUploads,
  cancelFileUpload,
};

export default connect(mapStateToProps, mapDispatchToProps);
